import React from "react";
import * as aor from "react-admin";

import CardActions from "@material-ui/core/CardActions";

import myRestClient from "../../common/restClient";
import { POLICY_COMPANIES } from "../../common/rolesManagement";
import { getUserCompany, getPolicies } from "../../common/authClient";
import MyChipField from "../../components/MyChipField";

class MyCreateCompanyButton extends React.Component {
    state = { button_visible: false, data_fetched: false };

    // The component in the case of an admin_ts_var user checks if the login company is master or controlled
    // in case it is a master, it shows the create button, otherwise it doesn't
    componentWillReceiveProps() {
        if (
            this.props.permissions &&
            (this.props.permissions.includes(POLICY_COMPANIES.CREATE) ||
                this.props.permissions.includes(POLICY_COMPANIES.SAFE_CREATE))
        ) {
            if (this.props.permissions.includes(POLICY_COMPANIES.SAFE_CREATE)) {
                if (!this.state.data_fetched) {
                    myRestClient("GET_ONE", "companies", {
                        id: getUserCompany()
                    }).then(
                        result => {
                            const visible = result.data.master_company_id
                                ? false
                                : true;
                            this.setState({
                                button_visible: visible,
                                data_fetched: true
                            });
                        },
                        error => {
                            console.log(error);
                            this.setState({ button_visible: false });
                        }
                    );
                }
            } else {
                this.setState({ button_visible: true });
            }
        } else {
            this.setState({ button_visible: false });
        }
    }

    render() {
        if (this.state.button_visible) {
            return <aor.CreateButton basePath={this.props.basePath} />;
        } else {
            return null;
        }
    }
}

const ConditionalEditButton = ({ record, ...props }) =>
    // admin_var can edit only slave companies
    // admin_console can edit all
    (record &&
        record.master_company_id &&
        props.permissions.includes(POLICY_COMPANIES.UPDATE_SLAVE_ONLY)) ||
    props.permissions.includes(POLICY_COMPANIES.UPDATE) ? (
        <aor.EditButton record={record} {...props} />
    ) : null;

const Filter = props => (
    <aor.Filter {...props}>
        <aor.TextInput source="vatin" alwaysOn={true} />
        <aor.TextInput source="name" alwaysOn={true} />
        {props.permissions &&
            (props.permissions.includes(POLICY_COMPANIES.DISABLE) ||
                props.permissions.includes(
                    POLICY_COMPANIES.DISABLE_SLAVE_ONLY
                )) && (
                <aor.BooleanInput
                    source="deleted"
                    alwaysOn={true}
                    label="Disabilitate"
                />
            )}
    </aor.Filter>
);

const Actions = ({ permissions, basePath }) => (
    <CardActions style={{ zIndex: 2, display: "inline-block", float: "right" }}>
        <span>
            <MyCreateCompanyButton
                basePath={basePath}
                permissions={permissions}
            />
        </span>
    </CardActions>
);

export default props => (
    <aor.List
        {...props}
        actions={<Actions permissions={getPolicies()} />}
        filters={<Filter permissions={getPolicies()} />}
        sort={{ field: "name", order: "ASC" }}
        bulkActionButtons={false}
        title="resources.companies.views.list.title"
    >
        <aor.Datagrid>
            <aor.TextField source="vatin" />
            <aor.TextField source="name" />
            <aor.TextField source="seller_code" />
            <aor.ReferenceField
                source="master_company_id"
                reference="companies"
                linkType="show"
                allowEmpty
            >
                <MyChipField source="name" {...props} />
            </aor.ReferenceField>
            {getPolicies() && getPolicies().includes(POLICY_COMPANIES.READ) && (
                <aor.ShowButton />
            )}
            <ConditionalEditButton permissions={getPolicies()} />
        </aor.Datagrid>
    </aor.List>
);



// WEBPACK FOOTER //
// ./src/resources/Companies/List.js